import { Controller } from "@hotwired/stimulus"

// Controls the X-18 role-equivalence pair editor.
//
// Targets:
//   list — container holding pair rows
//   row  — each pair row (rol A → rol B)
//
// Values:
//   roles    — array of available role names (strings)
//   paramKey — planning_rule[params][:equivalences] → "equivalences"
//   labels   — localized UI labels { roleA, roleB, countsAs, removePair }
export default class extends Controller {
  static targets = ["list", "row"]
  static values = { roles: Array, paramKey: String, namePrefix: String, labels: Object }

  add() {
    const roles = this.rolesValue || []
    const paramKey = this.paramKeyValue || "equivalences"
    const labels = this.labelsValue || {}
    // namePrefix lets the same editor live in a non-planning_rule form (e.g. the
    // per-activity shift modal: "shift[role_equivalences]"). Defaults to the
    // team-wide planning_rule param path so existing usage is unchanged.
    const prefix = this.namePrefixValue || `planning_rule[params][${paramKey}]`
    const options = roles.map((r) => `<option value="${this._escape(r)}">${this._escape(r)}</option>`).join("")

    const row = document.createElement("div")
    row.className = "flex flex-wrap items-center gap-2 mb-2 p-2 bg-gray-50 rounded-lg"
    row.setAttribute("data-role-equivalence-pairs-target", "row")
    row.innerHTML = `
      <select name="${prefix}[][from]" class="text-xs border rounded px-2 py-1">
        <option value="">${this._escape(labels.roleA || "Rol A...")}</option>${options}
      </select>
      <span class="text-xs text-gray-500">${this._escape(labels.countsAs || "telt als")}</span>
      <select name="${prefix}[][to][]" class="text-xs border rounded px-2 py-1">
        <option value="">${this._escape(labels.roleB || "Rol B...")}</option>${options}
      </select>
      <button type="button" data-action="role-equivalence-pairs#remove" class="text-red-500 hover:text-red-700 text-xs" aria-label="${this._escape(labels.removePair || "Verwijder paar")}">
        <i class="fas fa-times"></i>
      </button>
    `
    this.listTarget.appendChild(row)
  }

  remove(event) {
    const row = event.target.closest("[data-role-equivalence-pairs-target='row']")
    if (row) row.remove()
  }

  _escape(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }
}
